import { Component, OnInit } from '@angular/core';
import { APP_TEXT_EN, APP_TEXT_ES, FINRA_DISCLOSURE_TEXT } from '../../../shared/constants/app.constants';
import { GlobalService } from '../../../shared/services/global.service';
import { UtilService } from 'src/app/shared/services/utils.service';
import { SharedDataService } from 'src/app/shared/services/registration.service';

@Component({
  selector: 'app-host-section',
  templateUrl: './host-section.component.html',
  styleUrls: ['./host-section.component.scss']
})

export class HostSectionComponent implements OnInit {

  public ctaDisabled:boolean = false;
  public language : string = 'EN';
  public textConstants: any = this.language === 'EN' ? APP_TEXT_EN : APP_TEXT_ES;

  public title: string = this.textConstants.HOSTS.TITLE;
  public ctaButtonText: string = this.textConstants.HOSTS.CTA_BUTTON_TEXT;
  public eventCount: number = 0;
  langDictionary:any;
  showSection!:boolean
  public hosts: any[] = []
  public finraDisclosure = FINRA_DISCLOSURE_TEXT
  showFinraDisclosure:boolean = false;

  constructor(private globalService: GlobalService, private scrollService: UtilService, private sharedDataService: SharedDataService) { }

  ngOnInit(): void {
    this.sharedDataService.ctaDisableData.subscribe(data=>{
      this.ctaDisabled = data;
    })
    this.langDictionary = this.globalService.Language;  
    this.globalService.jobInformation.subscribe((data) => {
      this.showSection = (data?.pageData?.sectionSpeakers?.hideSection)?false:true;
      this.eventCount = data.eventCount || 0;
      if (this.eventCount < 2) {
        this.ctaButtonText = data?.pageData?.sectionSpeakers?.ctaButtonSelectEvent || this.langDictionary.HOSTS.CTA_BUTTON_TEXT_SINGLE;
      }else{
        this.ctaButtonText = data?.pageData?.sectionSpeakers?.ctaButtonSelectEvent || this.langDictionary.HOSTS.CTA_BUTTON_TEXT;
      }
      if (this.hosts.length < 2) {
        this.title = data?.pageData?.sectionSpeakers?.title || this.langDictionary.HOSTS.TITLE_SINGLE;
      }else{
        this.title = data?.pageData?.sectionSpeakers?.title || this.langDictionary.HOSTS.TITLE;
      }

      this.hosts = data?.pageData?.sectionSpeakers?.speakers
      this.showFinraDisclosure = data?.pageData?.disclaimers?.finra;
    });
  }

  register(){
    if(this.globalService.eventCount == 1){
      this.scrollService.triggerScroll('scrollToRegister');
    } else if(this.globalService.eventCount > 1){
      this.scrollService.triggerScroll('scrollToEvents');
    }
  }

}
